module.exports = "<div class=\"container\">\n\n  <app-slides></app-slides>\n  <div class=\"text-center\">\n  \t<button class=\"btn btn-primary startRuleBtn\" routerLink=\"/rules/new/step-1\" id=\"intro-done\">Start Creating Rules</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/landing/landing.component.html
// module id = 1432
// module chunks = 1